import DefaultHeader from "../CommonUtils/DefaultHeader";
import LandingPageHeader from "./LandingPageHeader";
import ConversationList from "./ConversationList";
import "../LandingPage/LandingPageStyleSheet.css";
import xmppService from "../Services/XMPPService";
import HWLog from "../HWLibrary/HWLog";
import HWUser from "../HWLibrary/HWUser";
import { getUserLocation, saveUILogs } from "../HWLibrary/HWUtils";
import CircularProgress from "@material-ui/core/CircularProgress";
import { CometdActions } from "../../cometD/cometD-action";
import CometDMiddleWare from "../../cometD/cometD-middleware";
import { MyContext } from "../../context/Mycontext";
import { s360ConfigService } from "../Services/S360Config";
import { resetRestartButtonFlag } from "../Services/HWIframeBridge";

class LandingPage extends CometDMiddleWare {
  constructor(props) {
    super(props);
    this.name = "LandingPage";
    this.state = {
      agentsList: [],
      sessionsList: [],
      healthPings: {},
      areAllPreviousSessionsClosed: false,
      isFetchingConversations: true,
    };
    this.logsInterval = null
  }
  // assigning context to current page context
  static contextType = MyContext

  render() {
    let hideHis = this.props.config.hideChatHis;
    return (
      <>
        {hideHis && (
          <div style={{ height: "100%", width: "100%", background: "#fff" }}>
            <div style={{ textAlign: "center", paddingTop: "60%" }}>
              <CircularProgress color="inherit" size={20} />
            </div>
          </div>
        )}
        {!hideHis && (
          <div className="s360-conversation-list-view-container">
            {/* <DefaultHeader {...this.props} {...this.state} /> */}
            <LandingPageHeader {...this.props} {...this.state} />
            <div
              style={{
                height: "100%",
                width: "100%",
                background: "#fff",
                minHeight: "100%",
              }}
            >
              <div
                style={{
                  height: "58%",
                  overflowY: "auto",
                  marginTop: "-35px",
                  width: "84%",
                  marginLeft: "8%",
                  maxHeight: "52%",
                  "box-shadow": "0px 200px 200px 56px rgba(0,0,0,0.05)",
                  "-webkit-box-shadow":
                    " 0px 200px 200px 56px rgba(0,0,0,0.05)",
                  "-moz-box-shadow": "0px 200px 200px 56px rgba(0,0,0,0.05)",
                  "border-radius": "20px",
                }}
              >
                <ConversationList
                  {...this.props}
                  {...this.state}
                  onScrollToBottom={this.onConversationScrollToBottom}
                  landingPageActions={this.landingPageActions}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  componentDidMount() {
    if (HWUser.isLoggedIn()) {
      console.log("COMETD-LOG-CHECK:4 componentDidMount in landing page, when user is LoggedIn");
      this.configureCometd();
    }
    if (!!this.props.config?.hideChatHis) {
      this.logsInterval = setInterval(() => {
        this.props.showLogsModal()
      }, 5000);
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount()

    if (this.logsInterval) {
      clearInterval(this.logsInterval);
    }
  }

  // Should be called after login.
  configureCometd = async () => {
    await this.props.configureCometd(
      this.context.userData.clientChannel,
      this.context.userData.cometUser,
      this.context.userData.cometToken,
      this.props.appRef
    );
    this.fetchConversationsCometd();
  };

  doMoveToNewConversation = false;
  fetchAgentsCometd = () => {
    //SEND A COMETD REQUEST FOR AGENTS GET THE LIST
    //1.LISTEN TO RESPONSE
    //2.ON RESPONSE DISPLAY THAT INFORMATION
  };
  fetchConversationsCometd = (lastFetchedSession) => {      
    const { fetchConversationsCMD } = CometdActions(this.context.cometdInstance, this.context.userData)
    fetchConversationsCMD(30, lastFetchedSession);
    
    // alert("cometd handshake  successful, GET_SESSIONS_REQUEST called") // can be enabled in dev
    // MARK: Enable to log when GET_SESSIONS_REQUEST is called
    saveUILogs({ 
      timestamp: new Date().toISOString(),
      message: "LIVECHAT UI: CometD handshake successful, GET_SESSIONS_REQUEST called"
    })

    //SEND A COMETD REQUEST FOR CONVERSATIONS GET THE LIST
    //1.LISTEN TO RESPONSE
    //2.ON RESPONSE DISPLAY THAT INFORMATION
  };

  fetchHealthPings = () => {
    return xmppService.fetchHealthPing("7958").catch((error) => {
      HWLog.error(error, "Fetch Health Error: ");
      return error;
    });
  };

  chatStatus = {
    Active: "Active",
    New: "New",
    Previous: "Previous",
  };
  landingPageActions = {
    createNewSessionCometd: () => {
      this.createNewSessionCometd();
    },
    checkAndStartNewConversationCometd: (session) => {
      this.checkAndStartNewConversationCometd(session);
    },
  };
  createNewSessionCometd = (sessionResponse) => {
    this.doMoveToNewConversation = true;
    const { createSessionCMD } = CometdActions(this.context.cometdInstance, this.context.userData)
    
    // Check if restart button was clicked
    const restartButtonClicked = s360ConfigService.restartButtonClicked || false;
    
    // Call createSessionCMD with restart flag
    createSessionCMD(restartButtonClicked);
    
    // Reset the flag if it was true
    if (restartButtonClicked) {
      s360ConfigService.restartButtonClicked = false;
      resetRestartButtonFlag();
    }
    
    // MARK: ###
    saveUILogs({ 
      timestamp: new Date().toISOString(),
      message: "LIVECHAT UI: CREATE_SESSION called"
    })
  };
  checkAndStartNewConversationCometd = (session) => {
    console.log(
      "COMETD-LOG: CLICKED ON NEW CONVERSATION TAB OR EXISTING LIST",
      session
    );
    localStorage.removeItem("selectedLanguage");
    if (session !== null && session !== undefined) {
      if (session.active) {
        let sessionToBePassed = session;
        sessionToBePassed.sessionStatus = this.chatStatus.Active;
        this.props.actions.startConversation(sessionToBePassed);
      } else {
        let sessionToBePassed = session;
        sessionToBePassed.sessionStatus = this.chatStatus.Previous;
        this.props.actions.startConversation(sessionToBePassed);
      }

      //attach this session and call this.props.actions.startConversation
      //send it with an extra parameter such as activeSession/newSession --> so that in conversation page we detect that and do respective actions
    } else {
      // NEW SESSION
      this.createNewSessionCometd();
    }
  };

  onSessionsListResponseCometd = (message) => {
    console.log("COMETD-LOG:PARSED SESSIONS LIST MESSAGES", message);
    // MARK: ###
    saveUILogs({ 
      timestamp: new Date().toISOString(),
      message: "LIVECHAT UI: GET_SESSIONS_RESPONSE received"
    })
    if (!message.listSessionInfo || message.listSessionInfo.length === 0) {
      this.lastFetchedSessionListCount = 0;
      console.log("COMETD-LOG:EMPTY SESSIONS LIST");
      this.setState({ isFetchingConversations: false });
      if (this.props.config.hideChatHis) {
        this.checkAndStartNewConversationCometd();
      }
      return;
    }

    let conversations = this.state.conversations || [];
    let conversationIds = conversations.map((i) => i.sessionId);
    let newConversations = message.listSessionInfo.filter(
      (i) => conversationIds.indexOf(i.sessionId) === -1
    );
    this.lastFetchedSessionListCount = newConversations.length;

    let firstActiveConversation = [...newConversations].find(
      (conversation) => conversation.active
    );
    if (firstActiveConversation !== undefined) {
      this.setState({ activeSession: firstActiveConversation });
    }
    console.log("COMETD-LOG:1ST ACTIVE CONVERSATION", this.state.activeSession);
    // if(firstActiveConversation != undefined){ this.props.isActive(true) }
    // else { this.props.isActive(false); }

    // alert("GET_SESSIONS_RESPONSE received CREATE_SESSION or HISTORY_REQUEST called") // can be enabled in dev
    // MARK: Enable to log when GET_SESSIONS_RESPONSE is received

    if (this.props.config.hideChatHis) {
      if (typeof firstActiveConversation != "undefined") {
        let activeConvList = [...newConversations].filter(
          (conversation) => conversation.active
        );
        // AUTOMATICALLY MOVE TO CONVERSATION PAGE WITH NEW SESSION ID
        this.props.actions.startConversation(activeConvList[0]);
      } else {
        this.checkAndStartNewConversationCometd();
      }
    } else {
      this.setState({
        conversations: this.props.config.configDetails.showPreviousSession
          ? [...conversations, ...newConversations]
          : firstActiveConversation !== null &&
            firstActiveConversation !== undefined
          ? [firstActiveConversation]
          : [],
        isFetchingConversations: false,
        areAllPreviousSessionsClosed: newConversations.every(
          (conversation) => !conversation.active
        ),
      });
    }
  };

  onCreateSessionResponseCometd = (newSessionResponse) => {
    newSessionResponse.sessionStatus = this.chatStatus.New;
    console.log(" PAGE WITH NEW SESSION", newSessionResponse);
    if (this.doMoveToNewConversation) {
      this.props.actions.startConversation(newSessionResponse);
    }
  };

  updateComponent = (data) => {
    // this.removePreviousEvent(true);
    console.log(
      "COMETD-LOG:RECIEVED MESSAGE FROM COMETD",
      JSON.parse(data.message.data)
    );
    this.cometdActions(JSON.parse(data.message.data));
  };

  parseUniboxSingleRefresh= function(){
    this.props.uniboxSingleRefreshChange();
    console.log("IN LANDING PAGE REFRESH")
  }
  
  cometdActions = (message) => {
    if (!message) return;
    //  To add more cases, change it in XMPPService class.
    switch (message.command) {
      case "GET_AGENTS_RESPONSE":
        this.onAgentListResponse(message);
        break;
      case "UNIBOX_SINGLE_REFRESH":
        this.parseUniboxSingleRefresh(message);
        break;
      case "GET_SESSIONS_RESPONSE":
        this.onSessionsListResponseCometd(message);
        break;
      case "CREATE_SESSION":
        this.onCreateSessionResponseCometd(message);
        break;
      case "PING_RESPONSE":
        this.parseAgentStatusPingResponse(message);
        break;
      case "BOT_REPLY":
        this.onCreateSessionResponseCometd(message);
        break;
      default:
        break;
    }
  };

  // Parse Agents List Response.
  onAgentListResponse = (message) => {
    HWLog.info("PARSED AGENTS LIST MESSAGES", message);
    if (!message.listAgentInfo || message.listAgentInfo.length === 0) {
      HWLog.info("EMPTY AGENTS LIST");
      return;
    }
    this.setState({ agentsList: message.listAgentInfo });
  };

  // Parse Conversations List Response
  lastFetchedSessionListCount = 0;
  onSessionsListResponse = (message) => {
    HWLog.info("PARSED SESSIONS LIST MESSAGES", message);
    if (!message.listSessionInfo || message.listSessionInfo.length === 0) {
      this.lastFetchedSessionListCount = 0;
      HWLog.info("EMPTY SESSIONS LIST");
      this.setState({ isFetchingConversations: false });
      if (this.props.config.hideChatHis) {
        this.startNewConversation();
      }
      return;
    }
    console.log("mws", message);

    let conversations = this.state.conversations || [];
    let conversationIds = conversations.map((i) => i.sessionId);
    let newConversations = message.listSessionInfo.filter(
      (i) => conversationIds.indexOf(i.sessionId) === -1
    );
    this.lastFetchedSessionListCount = newConversations.length;

    let firstActiveConversation = [...newConversations].find(
      (conversation) => conversation.active
    );
    // if(firstActiveConversation != undefined){ this.props.isActive(true) }
    // else { this.props.isActive(false); }

    if (this.props.config.hideChatHis) {
      if (typeof firstActiveConversation != "undefined") {
        let activeConvList = [...newConversations].filter(
          (conversation) => conversation.active
        );
        this.props.actions.startConversation(activeConvList[0]);
      } else {
        this.startNewConversation();
      }
    } else {
      this.setState({
        conversations: this.props.config.configDetails.showPreviousSession
          ? [...conversations, ...newConversations]
          : firstActiveConversation !== null &&
            firstActiveConversation !== undefined
          ? [firstActiveConversation]
          : [],
        isFetchingConversations: false,
        areAllPreviousSessionsClosed: newConversations.every(
          (conversation) => !conversation.active
        ),
      });
    }
  };

  onCreateSessionResponse = (newSessionResponse) => {
    console.log("landingPage");
    if (this.doMoveToNewConversation) {
      this.props.actions.startConversation(newSessionResponse);
    }
  };

  // MARK: Health Ping, Fetch session agent helath pings,
  // fetchAgentHealthPing = (sessionId) => {
  //   const { sendHealthPing } = CometdActions();
  //   if (!sessionId) {
  //     HWLog.warn(
  //       "No Session Id Available To Fetch Session Agent Health Ping: "
  //     );
  //     return;
  //   }
  //   sendHealthPing(sessionId);
  // };

  //   GREEN - Online
  //   RED - Offline
  //   Yellow - Away
  parseAgentStatusPingResponse = (message) => {
    let sessionId = message.sessionId || "";
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }

    let conversations = (this.state.conversations || []).map((conversation) => {
      if (conversation.sessionId === sessionId) {
        conversation.active = status === "GREEN";
      }
      return conversation;
    });
    this.setState({ conversations: conversations });
    HWLog.info("AGENT PING STATUS: " + status);
  };

  // MARK: Handle Session Pagination
  onConversationScrollToBottom = () => {
    HWLog.info("SCROLLED TO BOTTOM:" + this.lastFetchedSessionListCount);
    if (this.lastFetchedSessionListCount === 0) {
      return;
    }
    this.fetchNextPageConversations();
  };

  fetchNextPageConversations = () => {
    if (this.state.isFetchingConversations) {
      return;
    }
    let conversations = this.state.conversations || [];
    if (conversations.length === 0) {
      return;
    }
    let lastConversation = conversations[conversations.length - 1];
    this.setState({ isFetchingConversations: true }, () => {
      this.fetchConversations(lastConversation).catch((error) => {
        this.setState({ isFetchingConversations: false });
      });
    });
  };

  // MARK: User Location
  sendCurrentUserLocation = () => {
    HWLog.info("GETTING USER LOCATION:");
    getUserLocation()
      .then((result) => {
        if (
          result &&
          result.coords &&
          result.coords.latitude &&
          result.coords.longitude
        ) {
          xmppService.sendUserLocation(
            result.coords.latitude,
            result.coords.longitude
          );
        } else {
          HWLog.warn("Invalid Location Result:");
        }
      })
      .catch((error) => {
        HWLog.warn("Could Not Get User Location:", error);
      });
  };
}

export default LandingPage;
